import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import * as fromAuthActions from '../store/actions/auth.actions';
import {distinctUntilChanged} from 'rxjs/operators';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  constructor(private fb: FormBuilder,
              private router: Router,
              private toastr: ToastrService,
              private store: Store<fromStore.AppState>) {
  }

  ngOnInit() {
    this.createLoginForm();
  }

  createLoginForm() {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  userLoginAction() {
    this.store.dispatch(new fromAuthActions.LoginUser(this.loginForm.value));

    this.store.select(s => s.auth).pipe(distinctUntilChanged((a) => (a.error !== null))).subscribe(res => {
      if (res.loggedIn) {
        this.router.navigate(['/freelancers']);
      } else if (!!res.error) {
        this.toastr.error(res.error);
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/login/login.component.ts